import React from 'react';

interface Props {
  pct: number | null;   // SOC to display + fill (0–100); null → "—"
  color: string;        // ring fill color (hex)
  size?: number;        // diameter in px
  glow?: boolean;       // pulsing glow (use while charging)
  bg?: string;          // cutout color — match the surface the ring sits on
  className?: string;
}

/** Conic-gradient SOC ring (from the approved Charge Control mockup). Pure CSS:
 *  a conic fill with an inset disc punching the hole. Center shows the SOC %. */
export default function ChargeRing({ pct, color, size = 48, glow, bg, className }: Props) {
  const filled = pct != null ? Math.max(0, Math.min(100, pct)) : 0;
  const style: React.CSSProperties = {
    width: size,
    height: size,
    ['--p' as any]: filled,
    ['--c' as any]: color,
    ['--ring-inset' as any]: `${Math.max(4, Math.round(size * 0.105))}px`,
  };
  if (bg) style['--ring-bg' as any] = bg;

  return (
    <div
      className={`cc-ring${glow ? ' cc-ring-charge' : ''}${className ? ` ${className}` : ''}`}
      style={style}
      role="img"
      aria-label={pct != null ? `${Math.round(pct)} percent charge` : 'No battery data'}
    >
      <span
        className={`font-bold tabular-nums ${pct == null ? 'text-slate-500' : 'text-white'}`}
        style={{ fontSize: Math.max(10, Math.round(size * 0.26)) }}
      >
        {pct != null ? `${Math.round(pct)}%` : '—'}
      </span>
    </div>
  );
}
